import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Paper, Tabs, Tab, Box } from '@mui/material';
import { FullSizeColumn } from '../../Components/FlexBox';
import Header from '../../Components/ContactListWrapper/EntriesWrapper/Header';
import StagesConfiguration from './StagesConfiguration';
import ActivityOutcomesConfiguration from './ActivityOutcomesConfiguration';
import { checkFeature } from '../../Router/routes';

const ActivityProgressManagement = function ActivityProgressManagement({
  reloadActivityOutcomes = () => {},
}) {
  const intl = useIntl();
  const [tab, setTab] = useState(
    checkFeature('CUSTOMER_CAMPAIGNS_FEATURE')
      ? 'STAGES_CONFIGURATION'
      : 'ACTIVITY_OUTCOMES_CONFIGURATION'
  );

  const handleChangeTab = (event, newTab) => {
    setTab(newTab);
  };

  return (
    <Box sx={{ padding: '8px', overflow: 'hidden', height: '100%' }}>
      <Paper id="activityprogressmanagement-paper" sx={{ height: '100%' }}>
        <FullSizeColumn sx={{ overflow: 'hidden' }}>
          <Header
            title="ACTIVITYPROGRESS_MANAGEMENT"
            hideSearchBar
            hideSorting
            hideFilters
            hideExportExcel
          />
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
            }}
          >
            <Tabs
              variant="fullWidth"
              value={tab}
              onChange={handleChangeTab}
              fontSize="0.9rem"
            >
              {checkFeature('CUSTOMER_CAMPAIGNS_FEATURE') && (
                <Tab
                  value="STAGES_CONFIGURATION"
                  label={intl.messages.STAGES_CONFIGURATION}
                />
              )}
              <Tab
                value="ACTIVITY_OUTCOMES_CONFIGURATION"
                label={intl.messages.ACTIVITY_OUTCOMES_CONFIGURATION}
              />
            </Tabs>
          </Box>
          {tab === 'STAGES_CONFIGURATION' &&
            checkFeature('CUSTOMER_CAMPAIGNS_FEATURE') && (
              <StagesConfiguration />
            )}
          {tab === 'ACTIVITY_OUTCOMES_CONFIGURATION' && (
            <ActivityOutcomesConfiguration
              reloadActivityOutcomes={reloadActivityOutcomes}
            />
          )}
        </FullSizeColumn>
      </Paper>
    </Box>
  );
};

export default ActivityProgressManagement;
